import { handlePdfDownload, PdfFileNameEnum } from "@utils/companyBrochure";
import { useEffect } from "react";

export enum ScrollTarget {
  toMobileAppQr = "toMobileAppQr",
  toSmartCharger = "toSmartCharger",
  install = "install",
  produce = "produce",
}

export enum HashAction {
  downLoadBrochureKor = "downLoadBrochureKor",
  downLoadBrochureEn = "downLoadBrochureEn",
}

const useHashListener = () => {
  useEffect(() => {
    let scrollTimeout: NodeJS.Timeout | number;

    const handleHashChange = () => {
      const formattedHash = window.location.hash?.replace("#", "");

      if (!formattedHash) {
        return;
      }

      if (formattedHash === HashAction.downLoadBrochureKor) {
        return handlePdfDownload(PdfFileNameEnum.KOR);
      }

      if (formattedHash === HashAction.downLoadBrochureEn) {
        return handlePdfDownload(PdfFileNameEnum.ENG);
      }

      const element = document.getElementById(formattedHash);
      if (element) {
        if (scrollTimeout) {
          clearTimeout(scrollTimeout);
        }

        scrollTimeout = setTimeout(() => {
          const elementPosition = element.getBoundingClientRect().top + window.scrollY; // 요소의 화면상 위치를 계산
          window.scrollTo({
            top: elementPosition - 100, // 100px 더 이동
            behavior: "smooth",
          });
        }, 500);
      }
    };

    // 페이지가 처음 로드될 때 hash가 있을 경우 스크롤 이동 처리
    handleHashChange();

    // hash 변경을 감지하는 이벤트 리스너 추가
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);
};


export default useHashListener;
